// visitors.reducers.ts
import { VisitorsAction } from '../constants';
import { initialVisitorsState, IVisitorsState } from '../state/visitors.state';

export const visitorsReducer = (
    state = initialVisitorsState,
    action: any,
): IVisitorsState => {
    switch (action.type) {
        case VisitorsAction.GetVisitorsSuccess: {
            return {
                ...state,
                visitors: action.data || [],
            };
        }

        case VisitorsAction.GetReasonsSuccess: {
            return {
                ...state,
                reasons: action.data,
            };
        }

        case VisitorsAction.GetDestinationsSuccess: {
            return {
                ...state,
                destinations: action.data,
            };
        }

        case VisitorsAction.GetSingleVisitorSuccess: {
            return {
                ...state,
                selectedVisitor: action.data,
            };
        }

        case VisitorsAction.PostVisitorSuccess: {
            return {
                ...state,
                visitors: [...state.visitors, action.data],
            };
        }

        case VisitorsAction.EditVisitorSuccess: {
            
            const updatedVisitors = Array.isArray(state.visitors) 
                ? state.visitors.map(visitor => {
                    if (visitor.id === action.data.id) {
                        return action.data;
                    }
                    return visitor;
                  })
                : [];
            
            return {
                ...state,
                visitors: updatedVisitors,
                selectedVisitor: action.data
            };
        }

        case VisitorsAction.DeleteVisitorSuccess: {
            console.log('action', action);
            return {
                ...state,
                visitors: state.visitors.filter(visitor => visitor.id !== action.visitorId)
            };
        }

        default:
            return state;
    }
};